import React from 'react'
import PropTypes from 'prop-types'
import styled, { useTheme } from 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import Text from 'components/atoms/text'
import Icon from 'components/atoms/icon'

function getColor(type) {
  return {
    neutral: 'text',
    info: 'actionsStandard',
    success: 'statePositive',
    warning: 'actionsCta',
    error: 'stateNegative',
  }[type]
}

const Container = styled.div`
  display: flex;
  padding: 16px;
  ${({ theme, type }) => {
    if (theme.toastBorderRadius) {
      const typeCap = type.charAt(0).toUpperCase() + type.slice(1)
      const bg = theme.colors['toast' + typeCap + 'Background']
      const border = theme.colors['toast' + typeCap + 'Border']
      return `
        align-items: center;
        background: ${bg};
        border: 1px solid ${border};
        border-radius: ${theme.toastBorderRadius}px;
      `
    }
    const color = theme.colors[getColor(type)]
    return `
      align-items: flex-start;
      background: ${color}33;
      border-top: 1px solid;
      color: ${color};
    `
  }}
`

const StyledIcon = styled(Icon)`
  margin-right: 16px;
`

const Close = styled(Icon)`
  margin-left: auto;
`

const Title = styled(Text)`
  margin-bottom: 12px;
`

const Message = styled(Text)`
  white-space: pre-wrap;
`

function Toast({ className, message, type }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const isRdc = !!theme.toastBorderRadius

  const color = getColor(type)
  const titleText = {
    neutral: t('info'),
    info: t('info'),
    success: `${t('success')}!`,
    warning: `${t('payAttention')}!`,
    error: `${t('error')}!`,
  }[type]
  const icon = {
    neutral: 'checkCircleOutline',
    info: 'checkCircleOutline',
    success: 'checkCircleOutline',
    warning: 'errorOutline',
    error: 'errorOutline',
  }[type]

  return (
    <Container className={className} type={type}>
      <StyledIcon color={color} size="md" type={icon} />
      {isRdc ? (
        <Message type="h5" text={message} />
      ) : (
        <div>
          <Title color={color} text={titleText} />
          <Message type="h5" text={message} />
        </div>
      )}
      <Close color={color} size="sm" type="close" />
    </Container>
  )
}

Toast.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['neutral', 'info', 'success', 'warning', 'error']).isRequired,
}

Toast.defaultProps = {
  className: null,
}

export default Toast
